import React from "react";
import Grid, { GridProps as MuiGridProps } from "@material-ui/core/Grid";
import Paper, { PaperProps as MuiPaperProps } from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";

type Props = {
  [other: string]: any;
  GridProps?: Partial<MuiGridProps>;
  PaperProps?: Partial<MuiPaperProps>;
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(),
    flex: "1 0 100%",

    "&:not(:last-child)": {
      marginBottom: theme.spacing()
    }
  },

  subsection: {
    alignItems: "center",

    "&:not(:last-child)": {
      marginBottom: theme.spacing()
    },

    "& > div": {
      alignItems: "center",
      padding: `${theme.spacing()}px ${theme.spacing(3)}px` // because spacing on form.section is anyway in px already
    }
  }
}));

/**
 * Display left label and the field together inside grid items
 */
export function FormSubsection({ children, PaperProps, GridProps, ...rest }: Props) {
  const classes = useStyles({});
  return (
    <Paper elevation={1} className={classes.root} {...PaperProps} {...rest}>
      <Grid container spacing={8} className={classes.subsection} {...GridProps}>
        {children}
      </Grid>
    </Paper>
  );
}
